import { useEffect, useState } from 'react';
import { api } from './api';
import { Tenant } from './types';
import { applyBrandingToCSS } from './theme';

export function useTenant() {
  const [tenant, setTenant] = useState<Tenant | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api<Tenant>('/widget/tenant/')
      .then((t) => {
        setTenant(t);
        applyBrandingToCSS(t.branding);
        if (t.display_name) document.title = `${t.display_name} — FitBOXX`;
      })
      .catch(() => setTenant(null))
      .finally(() => setLoading(false));
  }, []);
  return { tenant, loading };
}

export function useAsync<T>(fn: () => Promise<T>, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const reload = () => {
    setLoading(true);
    return fn()
      .then((d) => { setData(d); setError(null); })
      .catch((e) => setError(e as Error))
      .finally(() => setLoading(false));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, deps);
  // `refresh` is an alias for `reload` kept for the many call sites that use it.
  return { data, loading, error, reload, refresh: reload };
}
